export default "__VITE_ASSET__GHX8Bb3d__"